const TRACKING_PARAM_PREFIXES = ['utm_'];
const TRACKING_PARAM_NAMES = new Set([
  'source',
  'ref',
  'referrer',
  'referer',
  'via',
  'origin',
  'campaign',
  'medium',
  'fbclid',
  'gclid',
  'msclkid',
  'mc_cid',
  'mc_eid',
]);

const isTrackingParam = (key = '') => {
  const lower = key.toLowerCase();
  if (TRACKING_PARAM_NAMES.has(lower)) return true;
  return TRACKING_PARAM_PREFIXES.some((prefix) => lower.startsWith(prefix));
};

/** Remove tracking query params so ATS/job boards cannot infer autobid as source. */
export const stripTrackingParams = (rawUrl = '') => {
  if (!rawUrl || typeof rawUrl !== 'string') return rawUrl;

  const trimmed = rawUrl.trim();
  if (!trimmed || trimmed.startsWith('mailto:')) return trimmed;

  try {
    const urlObj = new URL(trimmed);

    for (const key of Array.from(urlObj.searchParams.keys())) {
      if (isTrackingParam(key)) {
        urlObj.searchParams.delete(key);
      }
    }

    const cleaned = urlObj.toString();
    return cleaned.endsWith('?') ? cleaned.slice(0, -1) : cleaned;
  } catch {
    const [basePart, hash = ''] = trimmed.split('#');
    const [path, search = ''] = basePart.split('?');
    if (!search) return trimmed;

    const keptParams = search
      .split('&')
      .filter((pair) => {
        const [key] = pair.split('=');
        return key && !isTrackingParam(key);
      })
      .join('&');

    const rebuilt = keptParams ? `${path}?${keptParams}` : path;
    return hash ? `${rebuilt}#${hash}` : rebuilt;
  }
};

export const EXTERNAL_LINK_REL = 'noopener noreferrer';

export const openExternalUrl = (rawUrl) => {
  const url = stripTrackingParams(rawUrl);
  if (!url) return null;
  return window.open(url, '_blank', 'noopener,noreferrer');
};
